import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { PriceAdjustmentModel } from 'models/generated/Entities.Accounting.PriceAdjustment';
import { PriceAdjustmentValueModel } from 'models/generated/Entities.Accounting.PriceAdjustmentValue';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class PriceAdjustmentService {
	private baseUrl = `${environment.gatewayUrl}/api/price-adjustments`;

	constructor(private readonly http: HttpClient) {
	}

	getAllPriceAdjustments(): Promise<PriceAdjustmentModel[]> {
		return firstValueFrom(this.http.get<PriceAdjustmentModel[]>(this.baseUrl)).then(priceAdjustments => {
			// Sort accountingplan setups so the most recent is listed first
			for (let priceAdjustmentTable of priceAdjustments) priceAdjustmentTable.accountingPlanSetups.sort((a, b) => {
				const dateA = new Date(a.endDate ?? new Date()).getTime();
				const dateB = new Date(b.endDate ?? new Date()).getTime();
				return dateB - dateA;
			});
			
			return priceAdjustments;
		});
	}

	savePriceAdjustment(priceAdjustment: PriceAdjustmentModel): Promise<void> {
		priceAdjustment.include(pa => pa.priceAdjustmentValues);
		return firstValueFrom(this.http.put<void>(`${this.baseUrl}/${priceAdjustment.id}`, priceAdjustment));
	}
}
